export const dnldSMSAccounts = (builder) => ({
    dnldSMSAccounts: builder.mutation({
      query: ({ enterprise_id, search, loggedin_user_id, user_type_id, enterprise_user_id }) => {
        return {
          url: '/download_registered_smpp_list',
          method: 'GET',
          params: { enterprise_id, search, loggedin_user_id, user_type_id, enterprise_user_id },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
